import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Modal from "@/features/shared/components/Modal/Modal";
import StateForm from "@/features/taskState/components/StateForm";
import useTaskStates from "@/features/taskState/hooks/useTaskStates";
import StateKanbanBoard from "@/features/taskState/components/StateKanbanBoard";
import { toast } from "react-toastify";
const StateManagementPage = () => {
    const { taskStates, loading, error, refetchTaskStates, addTaskState, updateTaskState, deleteState, switchStates, } = useTaskStates();
    const [modalVisible, setModalVisible] = useState(false);
    const [editingState, setEditingState] = useState(null);
    const handleOpenModal = (state) => {
        setEditingState(state || null);
        setModalVisible(true);
    };
    const handleCloseModal = () => {
        setEditingState(null);
        setModalVisible(false);
    };
    const handleSwitchStates = async (idState, idStateToSwitchWith) => {
        try {
            await switchStates({ idState, idStateToSwitchWith });
            toast.success("États mis à jour");
        }
        catch (error) {
            console.error("Erreur lors du switch des états :", error);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleFormSubmit = async (data) => {
        try {
            if (editingState && data.id) {
                const payload = {
                    id: data.id,
                    code: data.code,
                    label: data.label,
                    indic_display: data.indic_display,
                    indic_relance: data.indic_relance,
                };
                if (data.sequence !== undefined) {
                    payload.sequence = data.sequence;
                }
                if (data.color !== undefined) {
                    payload.color = data.color;
                }
                if (data.icon_svg !== undefined) {
                    payload.icon_svg = data.icon_svg;
                }
                if (data.destination_states !== undefined) {
                    payload.destination_states = data.destination_states;
                }
                if (data.source_states !== undefined) {
                    payload.source_states = data.source_states;
                }
                await updateTaskState(payload);
                toast.success("État modifié");
            }
            else {
                const payload = {
                    code: data.code,
                    label: data.label,
                    indic_display: data.indic_display,
                    indic_relance: data.indic_relance,
                };
                if (data.sequence !== undefined) {
                    payload.sequence = data.sequence;
                }
                if (data.color !== undefined) {
                    payload.color = data.color;
                }
                if (data.icon_svg !== undefined) {
                    payload.icon_svg = data.icon_svg;
                }
                if (data.destination_states !== undefined) {
                    payload.destination_states = data.destination_states;
                }
                if (data.source_states !== undefined) {
                    payload.source_states = data.source_states;
                }
                await addTaskState(payload);
                toast.success("État enregistré");
            }
            handleCloseModal();
        }
        catch (error) {
            console.error("Erreur lors de la soumission du formulaire :", error);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleDelete = async (id) => {
        try {
            await deleteState(id);
            toast.success("État supprimé");
        }
        catch (error) {
            console.error("Erreur lors de la suppression de l'état :", error);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement..." });
    }
    if (error) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur : ", error, _jsx("button", { onClick: () => refetchTaskStates(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsx("div", { className: "flex flex-col sm:flex-row justify-end p-2", children: _jsx("button", { onClick: () => handleOpenModal(), className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "+ Ajouter un \u00C9tat" }) }), _jsx(StateKanbanBoard, { taskStates: taskStates, onClickUpdateState: handleOpenModal, onDeleteState: handleDelete, onSwitchState: handleSwitchStates }), modalVisible && (_jsx(Modal, { onClose: handleCloseModal, children: _jsx(StateForm, { initialData: editingState ?? undefined, onSubmit: handleFormSubmit, onCancel: handleCloseModal }) }))] }));
};
export default StateManagementPage;
